import { useMutation } from '@ngtrvu/use-api';
import { useQueryClient } from '@tanstack/react-query';
import { Form, message } from 'antd';
import PageTitle from 'apps/home/components/PageTitle';
import { useNavigate, useParams } from 'react-router-dom';
import { convertFormData, normalizeData } from 'utils/formData.js';

const AdminCreate = ({ ItemForm, apiCall, title, listUrl, initialValues }) => {
  const [form] = Form.useForm();
  const params = useParams();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const {
    mutate: submitItem,
    isPending: isSubmitting,
    error: submitItemError,
  } = useMutation(apiCall.create, {
    onSuccess: () => {
      // Invalidate the list query to refetch fresh data
      if (apiCall.list) {
        queryClient.invalidateQueries({
          queryKey: [apiCall.list.queryKey],
        });
      }
      message.success(`${title} created successfully`);
      navigate(listUrl);
    },
  });

  const onFinish = (values, photoFields = ['photo']) => {
    const postData = async () => {
      try {
        let submitData = normalizeData(values);
        let isConvertFormData = false;

        for (let i = 0; i < photoFields.length; i++) {
          const field = photoFields[i];
          const fieldValue = values[field];
          console.log('fieldValue', fieldValue);
          if (
            fieldValue &&
            fieldValue.at(-1) &&
            fieldValue.at(-1).originFileObj instanceof File
          ) {
            submitData[field] = values[field].at(-1).originFileObj;
            isConvertFormData = true;
          } else if (submitData.hasOwnProperty(field)) {
            delete submitData[field];
          }
        }
        if (isConvertFormData) {
          submitData = convertFormData(submitData);
        }
        submitItem({ ...params, payload: submitData });
      } catch (error) {
        console.error(error.message);
      }
    };

    postData();
  };

  return (
    <>
      <PageTitle title={title} backUrl={listUrl} />
      <ItemForm
        params={params}
        submiting={isSubmitting}
        form={form}
        initialValues={initialValues}
        onFinish={onFinish}
        name="create_form"
      />
    </>
  );
};

export default AdminCreate;
